import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import { TabView, TabPanel } from 'primereact/tabview';
import CustomGreetingFilter from '../../../components/metricsScoreCard/CustomGreetingFilter';
import { ToDoListBox } from '../../../components/myToDoList/MyToDoList';
import NotificationList from '../../../components/notificationList/NotificationList';
import { MetricsScoreCard } from '../../../components/metricsScoreCard/MetricsScoreCard';
import { MetricQualifiers } from '../../../components/metricQualifiers/MetricQualifiers';
import MetricRankings from '../metricRankings/metricRankings';
import { ShoutOutCarousel } from '../../coaching/toDoView/shoutOutCarousel/ShoutOutCarousel';
import {
    selectCurrentEmpid,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
} from '../../../pages/login/authSlice';
import {
    useGetEmployeeNotificationsQuery,
    useUpdateNotificationMutation,
} from '../../header/notifications/notificationSlice';
import { NotificationItem } from '../../../components/notificationList/types';
import { useGetShoutOutCarouselQuery } from '../../coaching/toDoView/toDoViewSlice';
import { getRole } from '../../../utils/roleUtils';
import MetricAttainment from '../../../components/metricAttainment/MetricAttainment';
import { useGetEmpMonthlyMetricAttainmentQuery } from '../../../pages/metricdashboard/metricDashboardSlice';

export const AgentLandingPage = () => {
    const loggedUser = useSelector(selectCurrentUser);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [notifications, setNotifications] = useState<NotificationItem[]>([]);
    const [UpdateNotification] = useUpdateNotificationMutation();
    const [inputMonth, setInputMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setInputYear] = useState(new Date().getFullYear());
    const userMngrRole = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const [scorecardVersion, setScorecardVersion] = useState<number>(0);
    const [calendarDate, setCalendarDate] = useState(new Date());

    const { data: monthlyMetricAttainmentData } = useGetEmpMonthlyMetricAttainmentQuery(
            {
                employeenumber: loggedEmpNum?.toString(),
                year: inputYear,
                month: inputMonth,
                scorecardVersionId: scorecardVersion,
            },
            { skip: !loggedEmpNum || !inputYear || !inputMonth || !scorecardVersion }
        );
    const { data: employeeNotifications, isFetching: employeeNotificationsFetching } =
        useGetEmployeeNotificationsQuery({ employeeNumber: loggedEmpNum }, { skip: !loggedEmpNum });

    const { data: shoutOuts } = useGetShoutOutCarouselQuery({
        employeeNumber: loggedEmpNum,
        employeeRole: getRole(userMngrRole, isPseudoSupervisor),
    });

    useEffect(() => {
        if (!employeeNotificationsFetching) {
            if (employeeNotifications?.data?.length > 0) setNotifications(employeeNotifications.data);
            else setNotifications([]);
        }
    }, [employeeNotifications]);

    return (
        <div className="landing-page-wrapper">
            <div className="card bg-body rounded mt-3 border-0 homepagebody">
                {/* Greeting and Filter */}
                <div className="row mb-3">
                    <h3 className="homePageText">Welcome Back {loggedUser}!</h3>
                    <CustomGreetingFilter
                        inputmonth={inputMonth}
                        setInputMonth={setInputMonth}
                        inputyear={inputYear}
                        setInputYear={setInputYear}
                        scorecardVersionValue={setScorecardVersion}
                        calendarDate={calendarDate}
                        setCalendarDate={setCalendarDate}
                    />
                </div>

                {/* Main Grid */}
                <div className="full-height-row">
                    {/* Left Column */}
                    <div className="left-column-wrapper">
                        {/* ToDos + Notifications */}
                        <div className="card shadow bg-body border-0 rounded-4 todo-notification-card">
                            <div className="todo-notification-content h-100">
                                <div className="todo-column border-end pe-2">
                                    <div className="section-header px-3 pt-3">My To Do&apos;s List</div>
                                    <ToDoListBox type="mytodos" via="agentLandingPage" />
                                </div>
                                <div className="notification-column ps-2">
                                    <div className="section-header px-3 pt-3">Alerts & Notifications</div>
                                    <div className="scrollable-section px-3">
                                        <NotificationList
                                            notifications={notifications}
                                            onNotificationRead={(id) => {
                                                const notification = {
                                                    employeenumber: loggedEmpNum,
                                                    isNotificationRead: true,
                                                    notificationId: id,
                                                    readAll: false,
                                                };
                                                UpdateNotification(notification)
                                                    .unwrap()
                                                    .then((res: any) => console.log('Marked as read', res))
                                                    .catch((err: any) => console.error('Update failed', err));
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Metrics + Qualifiers */}
                        <div className="card shadow bg-body border-0 rounded-4 metrics-qualifiers-card">
                            <div style={{ fontSize: '1.25rem', padding: '0.5rem 0.5rem 0', color: '#3F5765' }}>My Metrics</div>
                            <div>
                                <div className="metrics-section">
                                    <MetricsScoreCard
                                        agentnumber={loggedEmpNum}
                                        scorecardVersion={scorecardVersion}
                                        inputmonth={inputMonth}
                                        inputyear={inputYear}
                                    // isPayoutMetric
                                    />
                                </div>
                                {monthlyMetricAttainmentData?.data[0]?.scorecard_calculation_rule_id === 2 && (
                                <div className='metricAttainment' style={{margin:'11px'}}>
                                     <MetricAttainment data={monthlyMetricAttainmentData?.data || []}/>
                                </div>
                                )}
                                <div className="qualifiers-section">
                                    <MetricQualifiers
                                        empNum={loggedEmpNum}
                                        inputMonth={inputMonth}
                                        inputYear={inputYear}
                                        scorecardVersionID={scorecardVersion}
                                    />
                                </div>
                            </div>
                        </div>
                    </div> {/* end left-column-wrapper */}

                    {/* Right Column */}
                    <div className="right-column">
                        <div
                            className="p-card card shadow bg-body border-0 ranking-list-container"
                            style={{ borderRadius: '25px' }}
                        >
                            <div className="landing-page-ranking">
                                <MetricRankings
                                    empNum={loggedEmpNum}
                                    inputMonth={inputMonth}
                                    inputYear={inputYear}
                                    scorecardVersionID={scorecardVersion}
                                />
                            </div>
                        </div>
                        <div
                            className="bg-body border-0 shoutout-wrapper"
                            style={{ borderRadius: '25px', width: '100%' }}
                        >
                            <ShoutOutCarousel shoutOuts={shoutOuts?.data || []} via="agent_landingpage" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
